/**
 * Выгрузка таблицы показателей в CSV.
 *
 * Формат под Excel: точка с запятой как разделитель и BOM, иначе кириллица
 * открывается кракозябрами, а числа с пробелами уезжают в соседние колонки.
 */
export const downloadCsv = (rows, columns, modelName = 'model') => {
    if (!rows?.length) return

    const years = columns.slice(1).map(column => column.dataIndex)
    const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`

    const lines = [
        ['Показатель', ...years].map(escape).join(';'),
        ...rows.map(row => [
            escape(row.key),
            ...years.map(year => {
                const value = row[year]
                return value === undefined || value === null || isNaN(value)
                    ? '' : String(Math.round(value))
            }),
        ].join(';')),
    ]

    const blob = new Blob(['﻿' + lines.join('\r\n')], {type: 'text/csv;charset=utf-8;'})
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${modelName.replace(/\s+/g, '-').toLowerCase()}-показатели.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}
